function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import HubspotContactFormFields from "segments/desktop/core-components/hubspot-contact-form/fields-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
const QUOTE_FIELDS = {
    quoteText: {
        type: FIELD_TYPES.TEXT,
        label: "Quote text (supports HTML)",
        translatable: true
    },
    author: {
        type: FIELD_TYPES.TEXT,
        label: "Author (supports HTML)",
        translatable: true
    },
    avatars: {
        type: FIELD_TYPES.MULTIPLE_NESTED,
        label: "Avatars",
        nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: _object_spread({}, AssetFieldsConfig.image.fields)
        }
    }
};
export default {
    type: FIELD_TYPES.NESTED,
    label: "Hubspot With Quote Carousel",
    fields: _object_spread_props(_object_spread({}, HubspotContactFormFields), {
        quotes: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Quotes",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: QUOTE_FIELDS
            }
        },
        intervalMs: {
            type: FIELD_TYPES.TEXT,
            label: "Rotation interval (ms)"
        },
        benefitsTitle: {
            type: FIELD_TYPES.TEXT,
            label: "Benefits title",
            translatable: true
        },
        benefit1: {
            type: FIELD_TYPES.TEXT,
            label: "Benefit 1",
            translatable: true
        },
        benefit2: {
            type: FIELD_TYPES.TEXT,
            label: "Benefit 2",
            translatable: true
        },
        benefit3: {
            type: FIELD_TYPES.TEXT,
            label: "Benefit 3",
            translatable: true
        },
        supportText: {
            type: FIELD_TYPES.TEXT,
            label: "Support text (supports HTML)",
            translatable: true
        },
        logoSectionTitle: {
            type: FIELD_TYPES.TEXT,
            label: "Logo section title",
            translatable: true
        },
        logos: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Logos",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: _object_spread({}, AssetFieldsConfig.image.fields)
            }
        }
    })
};
